<template>
    <v-card height="100%">
        <v-card-text class="pa-4">
            <v-layout row>
                <v-flex xs12 class="mb-12 mt-6 text-center">
                    <div class="headline">
                        {{ message.subject }}
                    </div>
                    <div class="subheading">
                        Sent out to: {{ message.messageGroup.messageGroup }}
                    </div>
                </v-flex>
            </v-layout>
            <v-simple-table dense class="mb-12">
                <thead>
                    <tr>
                        <th class="text-left" colspan="2">
                            Message Info
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td style="width: 5%"><strong>Sender:</strong></td>
                        <td class="message-detail__displayedSender">
                            {{ message.user }}
                        </td>
                    </tr>
                    <tr>
                        <td><strong>Subject:</strong></td>
                        <td class="message-detail__displayedSubject">
                            {{ message.subject }}
                        </td>
                    </tr>
                    <tr>
                        <td><strong>Sent:</strong></td>
                        <td>
                            {{ formatDate(message.createdAt) }}
                        </td>
                    </tr>
                    <tr>
                        <td><strong>Type:</strong></td>
                        <td>
                            {{ message.messageType.messageType }}
                        </td>
                    </tr>
                    <tr>
                        <td><strong>Recipients:</strong></td>
                        <td>
                            {{ message.messageGroup.messageGroup }}
                        </td>
                    </tr>
                </tbody>
            </v-simple-table>
            <v-simple-table class="mb-12">
                <thead>
                    <tr>
                        <th class="text-left" colspan="3">Attachments</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <div>Incident Report.pdf</div>
                        </td>
                    </tr>
                </tbody>
            </v-simple-table>
            <v-simple-table class="mb-12">
                <thead>
                    <tr>
                        <th class="text-left" colspan="3">
                            Message
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="message-detail__displayedMessage">
                            {{ message.message }}
                        </td>
                    </tr>
                </tbody>
            </v-simple-table>
        </v-card-text>
        <v-card-actions class="justify-center pa-6">
            <v-btn class="print-button" color="primary" @click="print"
                ><v-icon class="mr-4">print</v-icon>Print</v-btn
            >
        </v-card-actions>
    </v-card>
</template>

<script>
import moment from 'moment';

export default {
    name: 'MessageDetail',
    props: {
        message: {
            type: Object,
            required: true,
            default: () => ({
                uid: '',
                user: '',
                subject: '',
                message: '',
                messageType: {
                    uid: '',
                    messageType: ''
                },
                messageGroup: {
                    uid: '',
                    messageGroup: ''
                },
                createdAt: ''
            })
        }
    },
    methods: {
        print() {
            document.body.classList.add('print-invoice');
            setTimeout(() => {
                print();
                document.body.classList.remove('print-invoice');
            });
        },
        formatDate(rawDate) {
            return moment(rawDate).format('dddd, MMMM Do YYYY, h:mm:ss a');
        }
    }
};
</script>

<style scoped>
thead th {
    background: rgba(0, 0, 0, 0.03);
    border-bottom: 1px solid #ccc;
    white-space: normal;
}
th {
    padding: 0.3rem 1rem !important;
    text-align: left;
    height: 40px;
}
tr:hover {
    background: none !important;
}
</style>

<style>
.print-invoice .application {
    background: none;
}
.print-invoice aside,
.print-invoice .v-tabs-bar,
.print-invoice .print-button,
.print-invoice .edit-invoice-button,
.print-invoice .v-navigation-drawer,
.print-invoice .page-header,
.print-invoice .no-print-col,
.print-invoice .v-footer {
    display: none !important;
}
.print-invoice .offset-left {
    margin-left: 16.6666666667%;
}
.print-invoice .container,
.print-invoice .v-container,
.print-invoice .v-content {
    padding: 0 !important;
    max-width: none;
    background: white !important;
}
.print-invoice div {
    border: none;
    box-shadow: none;
}

.print-invoice .print-footer {
    position: absolute;
    bottom: 0;
    width: 100%;
}
</style>
